import DestinationFilters from './DestinationFilters.component';
export default DestinationFilters;